// discord链接
const discordLinkTw = {
  igame: "https://discord.gg/pqRTrUwD4b"
};

export const regionStoreTw = {
  blockTask: [8],
  region: "tw",
  discordLink: discordLinkTw
};